import React, {　Component　} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import {　convertPipeToBrTag　} from "../../utils";
// ---
import {scrollToNode} from '../../utils';
import PhotoInfo from '../photo-info';
// ---
import './styles.css';
import RelatedVideo from "../related-video";
import BodyControl from "../../components/body";
import YoutubePlayer from "../../components/youtube-player";
import {WINDOW, DOCUMENT} from '../../constants/environment';

/**
 * heading - tag + text pare を作成します - {@link convertPipeToBrTag} で `|` to `<br>` 変換を行い insert します
 * @param {?string} tag heading tag
 * @param {?string} label tag 内 text - `dangerous` option true の時は HTML それ以外は pure text
 * @param {string} defaultTagName argument tag value が `Default` 時の代替 tag - HTML で定義されているタグを指定します
 * @param {string} [suffix=''] `baseClass` の末尾に追加する文字 `__` 連結します - 必須です
 * @param {boolean} [dangerous=false] HTML の時に `true` セットします
 * @param {string} [alternate=''] 代替データ - string
 * @param {string} [baseClass=HeroVideo__heading] `tag` 引数へ付与する class name 先頭文字
 * @returns {?Element} heading tag を返します
 * @constructor
 */
const HeadingTag = ({ tag, label, defaultTagName, suffix, dangerous, alternate, baseClass }) => {
  const labelText = (label !== null && label) ? label: alternate;
  if (labelText === null || !labelText) {
    return null;
  }
  // make attribute
  const attributes = {
    className: `${baseClass}${(suffix) ? '__': ''}${suffix}`,
  };
  // tag name
  const tagName = (tag) ? tag.toLowerCase() : 'default';
  // create element
  const Element = tagName === 'default' ? defaultTagName : tagName;
  // label is plane text
  if (!dangerous) {
    return (
      <Element
        {...attributes}
      >
        {labelText}
      </Element>
    );
  }
  // dangerous - label is HTML
  attributes.dangerouslySetInnerHTML = {__html: convertPipeToBrTag(labelText)};
  return <Element {...attributes} />;
};

HeadingTag.propTypes = {
  tag: PropTypes.string,
  label: PropTypes.string,
  defaultTagName: PropTypes.string.isRequired,
  suffix: PropTypes.string,
  dangerous: PropTypes.bool,
  alternate: PropTypes.string,
  baseClass: PropTypes.string,
};


HeadingTag.defaultProps = {
  tag: null,
  label: null,
  suffix: '',
  dangerous: false,
  alternate: '',
  baseClass: 'HeroVideo__heading',
};

// -----------------------------------------------
/**
 * description tag text 作成します
 * @param {?string} description 説明文
 * @param {string} [suffix=''] `baseClass` の末尾に追加する文字 `__` 連結します
 * @param {string} [alternate=''] 代替データ - string
 * @param {string} [baseClass=HeroVideo__heading] コンテナへ付与する class name 先頭文字
 * @returns {?Element} description tag を返します
 * @constructor
 */
const DescriptionTag = ({ description, suffix, alternate, baseClass }) => {
  const text = (description !== null && description) ? description: alternate;
  if (text === null || !text) {
    return null;
  }
  const className = `${baseClass}${(suffix) ? '__': ''}${suffix}`;
  return (
    <div className={`${className} Wysiwyg`} dangerouslySetInnerHTML={{__html: text}}/>
  );
};

DescriptionTag.propTypes = {
  description: PropTypes.string,
  suffix: PropTypes.string,
  alternate: PropTypes.string,
  baseClass: PropTypes.string,
};

DescriptionTag.defaultProps = {
  description: null,
  suffix: '',
  alternate: '',
  baseClass: 'HeroVideo__heading',
};

// -----------------------------------------------
/**
 * CTA link tag を作成します - large lint `imageLink` と共存できないので出力時に注意します
 * @param {?{href: string, text: string, type: string, targetBlank: boolean}} link props.link object
 * @param {string} [suffix=''] `baseClass` の末尾に追加する文字 `-` 連結します
 * @param {string} [baseClass=HeroVideo__btn__link] コンテナへ付与する class name 先頭文字
 * @returns {?Element} CTA `a` tag を返します
 * @constructor
 */
const CtaTag = ({ link, suffix, baseClass }) => {
  if (link === null || !link || !link.href || !link.text) {
    return null;
  }
  // a tag
  const type = link.type || '';
  return (
    <a
      href={link.href}
      className={`${baseClass}${(suffix) ? '-': ''}${suffix} ${type}`}
      target={(link.targetBlank) ? '_blank': '_self'}
    >
      {link.text}
    </a>
  );
};

CtaTag.propTypes = {
  link: PropTypes.shape(),
  suffix: PropTypes.string,
  baseClass: PropTypes.string,
};

CtaTag.defaultProps = {
  link: null,
  suffix: '',
  baseClass: 'HeroVideo__btn__link',
};

// -----------------------------------------------
/**
 * `span.HeroVideo__videoFilter` filter tag を作成します
 * @param {?boolean} filterFlag props.[pcVideoFilter|mbVideoFilter]
 * @param {string} [suffix=''] `baseClass` の末尾に追加する文字 `-` 連結します
 * @param {string} [baseClass=HeroVideo__videoFilter] コンテナへ付与する class name 先頭文字
 * @returns {?Element} `span.HeroVideo__videoFilter`
 * @constructor
 */
const FilterTag = ({ filterFlag, suffix, baseClass }) => {
  if (filterFlag === null || !filterFlag) {
    return null;
  }
  return <span className={`${baseClass}${(suffix) ? '-': ''}${suffix}`}/>;
};

FilterTag.propTypes = {
  filterFlag: PropTypes.bool.isRequired,
  suffix: PropTypes.string,
  baseClass: PropTypes.string,
};
FilterTag.defaultProps = {
  suffix: '',
  baseClass: 'HeroVideo__videoFilter',
};

// -----------------------------------------------
const LikeVideoPosterBackground = ({ src, suffix, videoVisible }) => {
  if (!src || videoVisible) {
    return null;
  }
  // video 非表示に表示する
  const style = {
    backgroundImage: `url(${src})`,
    // display: videoVisible ? 'none' : 'block',
  };
  return (
    <div
      className={`HeroVideo__video__poster HeroVideo__video__poster-${suffix}`}
      style={style}
    />
  );
};

LikeVideoPosterBackground.propTypes = {
  src: PropTypes.string,
  suffix: PropTypes.string.isRequired,
  videoVisible: PropTypes.bool.isRequired,
};

LikeVideoPosterBackground.defaultProps = {
  src: null,
};

// -----------------------------------------------

/**
 * HeroVideo component
 * - YouTube - modal で再生します
 * - inline 再生できない端末は poster 画像表示になります
 */
export default class HeroVideo extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    pcPreHeading: PropTypes.string,
    mbPreHeading: PropTypes.string,
    preHeadingTag: PropTypes.string,
    pcHeading: PropTypes.string,
    mbHeading: PropTypes.string,
    headingTag: PropTypes.string,
    pcDescription: PropTypes.string,
    mbDescription: PropTypes.string,
    pcPosition: PropTypes.string,
    mbPosition: PropTypes.string,
    pcTextAlign: PropTypes.string,
    mbTextAlign: PropTypes.string,
    youtubeId: PropTypes.string,
    pcVideoSrc: PropTypes.string,
    mbVideoSrc: PropTypes.string,
    pcVideoFilter: PropTypes.bool,
    mbVideoFilter: PropTypes.bool,
    pcLoop: PropTypes.bool,
    mbLoop: PropTypes.bool,
    pcSrc: PropTypes.string,
    mbSrc: PropTypes.string,
    pcSize: PropTypes.string,
    mbSize: PropTypes.string,
    link: PropTypes.shape({
      text: PropTypes.string,
      href: PropTypes.string,
      targetBlank: PropTypes.bool,
      type: PropTypes.string,
    }),
    imageLink: PropTypes.bool,
    scrollToSlug: PropTypes.bool,
    photoInfo: PropTypes.arrayOf(PropTypes.node),
    relatedVideo: PropTypes.arrayOf(PropTypes.node),
    // props extends
    photoInfoWillOpen: PropTypes.func,
    photoInfoWillClose: PropTypes.func,
    modalWillOpen: PropTypes.func,
    modalWillClose: PropTypes.func,
    inHeroCarousel: PropTypes.bool,
    heroCarouselSlideId: PropTypes.string,
    heroCarouselUniqueId: PropTypes.string,
    // ---
    sendMessage: PropTypes.func,
    requestMessageFlag: PropTypes.bool,
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    pcPreHeading: null,
    mbPreHeading: null,
    preHeadingTag: null,
    pcHeading: null,
    mbHeading: null,
    headingTag: null,
    pcDescription: null,
    mbDescription: null,
    pcPosition: null,
    mbPosition: null,
    pcTextAlign: null,
    mbTextAlign: null,
    youtubeId: null,
    pcVideoSrc: null,
    mbVideoSrc: null,
    pcVideoFilter: null,
    mbVideoFilter: null,
    pcLoop: null,
    mbLoop: null,
    pcSrc: null,
    mbSrc: null,
    pcSize: null,
    mbSize: null,
    link: null,
    imageLink: null,
    scrollToSlug: null,
    photoInfo: null,
    relatedVideo: null,
    // props extends
    photoInfoWillOpen: null,
    photoInfoWillClose: null,
    modalWillOpen: null,
    modalWillClose: null,
    inHeroCarousel: false,
    heroCarouselSlideId: '',
    heroCarouselUniqueId: '',
    // ---
    sendMessage: null,
    requestMessageFlag: false,
  };

  /**
   * props から state 情報を設定する
   * @param {*} props React.prop
   * @param {*} state React.state
   * @returns {*} 変更情報
   */
  static getDerivedStateFromProps(props, state) {
    // console.log('HeroVideo.getDerivedStateFromProps', props.heroCarouselSlideId !== state.heroCarouselSlideId, props.heroCarouselSlideId, state.heroCarouselSlideId);
    if (props.heroCarouselSlideId !== state.heroCarouselSlideId) {
      return {
        prevHeroCarouselSlideId: state.heroCarouselSlideId,
        heroCarouselSlideId: props.heroCarouselSlideId,
      };
    }
    return null;
  }

  /**
   * `div.RelatedVideo` が見つかるまで再帰的に parent 探索します
   * - `data-yt` から YouTube ID を取得します
   * @param {Node|HTMLElement|Element} target event target 探索起点 Node
   * @returns {?string} `data-yt` value - YouTube ID
   */
  static parseNode(target) {
    if (!target) {
      return null;
    }
    if (!target.classList || !target.classList.contains('RelatedVideo')) {
      return HeroVideo.parseNode(target.parentNode);
    }
    return target.dataset.yt;
  }

  constructor(props) {
    super(props);
    // ---
    /**
     * React.state
     * - isOpen - modal open class name - 'is-open' / ''
     * - mbHeight - mobile `Vertical` option container は `height` 必須 - image height
     * @type {{isOpen: string, mbHeight: ?number, visiblePc: boolean, visibleMb: boolean, entered: string, youtubeId: ?string, fitWidth: ?{}}}
     */
    this.state = {
      // modal open / close
      isOpen: '',
      // mb image height
      mbHeight: null,
      visiblePc: true,
      visibleMb: true,
      entered: '',
      // YouTube ID
      youtubeId: props.youtubeId,
      fitWidth: null,
      // extend
      heroCarouselSlideId: '',
      btnScrollClicked: '',
    };
    this.timer = {
      btnScroll: 0,
      btnEmpty: 0,
      waitPc: 0,
      waitMb: 0,
      pauseRewind: 0,
      // ---
      load: 0,
      figure: 0,
      playingPc: 0,
      playingMb: 0,
      checkPlayingPc: 0,
      checkPlayingMb: 0,
      firstVideoPlay: 0,
    };
    // console.log('HeroVideo', props.heroCarouselUniqueId);
    /**
     * bound onClickModalOpen - modal open event handler
     * @type {bound|any}
     */
    this.onClickModalOpen = this.onClickModalOpen.bind(this);
    /**
     * bound onClickModalClose - modal close event handler
     * @type {bound|any}
     */
    this.onClickModalClose = this.onClickModalClose.bind(this);
    /**
     * bound onClickInnerLink - scroll to hash `data-id["CSS_ID"]` event handler
     * @type {bound|any}
     */
    this.onClickInnerLink = this.onClickInnerLink.bind(this);
    /**
     * bound onPcVideoEnded - PC video ended event handler
     * @type {bound|any}
     */
    this.onPcVideoEnded = this.onPcVideoEnded.bind(this);
    /**
     * bound onMbVideoEnded - MB video ended event handler
     * @type {bound|any}
     */
    this.onMbVideoEnded = this.onMbVideoEnded.bind(this);
    /**
     * YouTube iframe 参照 - mount 後設定されます
     * @type {?Element}
     */
    this.youtubeIframe = null;
    /**
     * YouTube iframe src - `postMessage` 失敗する Browser のみ失敗時に設定されます
     * @type {string}
     */
    this.youtubeIframeSrc = '';
    /**
     * YouTube iframe id - 識別子として使用できるように念のために設定しておきます
     * @type {string}
     */
    this.youtubeIframeId = `HeroVideo__modal__movie-${Date.now()}`;
    // this.activate = this.activate.bind(this);
    // this.playVideo = this.playVideo.bind(this);
    /**
     * HTML5 video tag
     * @type {{pc: ?Element, mb: ?Element}}
     */
    this.videos = {
      pc: null,
      mb: null,
    };
    /**
     * HTML5 video ended flag
     * @type {{pc: boolean, mb: boolean}}
     */
    this.ended = {
      pc: false,
      mb: false,
    };
    // this.onResize = this.onResize.bind(this);
    /**
     * PC / MB breakpoint
     * - PC: >= 768
     * - MB: < 768
     * @type {number}
     */
    this.breakPoint = 768;
    /**
     * MB `Vertical` container 参照 - mount 後に設定されます
     * @type {?Element}
     */
    this.mbImg = null;
    // scroll to id
    const {link} = props;
    // href - `#HASH` なリンクがあるかをチェックする
    const href = (link && link.href) ? link.href: null;
    const hash = (href) ? href.split('#').pop(): null;
    /**
     * link.href から HASH 文字取り出す - page 内リンク sweet scroll - {@link scrollToElementId} で使用します
     * @type {?string}
     */
    this.targetId = (hash && hash !== href) ? hash: null;
    // console.log('HeroVideo', href, hash, this.targetId);
    /**
     * modal open class name
     * @type {string}
     */
    this.modalOpened = 'HeroVideo__modal__opened';
    /**
     * bound onClickModalCloseByContent - `div.HeroVideo__modal__content` click handler
     * @type {bound|any}
     */
    this.onClickModalCloseByContent = this.onClickModalCloseByContent.bind(this);
    /**
     * bound onPcVideoPlay - pc.video.play event handler
     * @type {bound|any}
     */
    this.onPcVideoPlay = this.onPcVideoPlay.bind(this);
    /**
     * bound onMbVideoPlay - mb.video.play event handler
     * @type {bound|any}
     */
    this.onMbVideoPlay = this.onMbVideoPlay.bind(this);
    /**
     * play flag
     * @type {{pc: boolean, mb: boolean}}
     */
    this.played = {
      pc: false,
      mb: false,
    };
    /**
     * poster 画像存在 flag
     * @type {{pc: boolean, mb: boolean}}
     */
    this.posters = {
      pc: false,
      mb: false,
    };
    /**
     * bound onLinkEnter - imageLink.onmouseenter handler
     * @type {bound|any}
     */
    this.onLinkEnter = this.onLinkEnter.bind(this);
    /**
     * bound onLinkLeave- imageLink.onmouseuleave handler
     * @type {bound|any}
     */
    this.onLinkLeave = this.onLinkLeave.bind(this);
    /**
     * bind onClickRelated - {@link RelatedVideo} click を親 Node で delegate します
     * @type {bound|any}
     */
    this.onClickRelated = this.onClickRelated.bind(this);
    /**
     * mb - vertical retry count - get video size
     * @type {number}
     */
    this.iniCount = 0;
    /**
     * `.hero` Element - cache のために用意したが {@link scrollToNode} が正しく位置取得できないので使用しない - 残しておく
     * @type {?Element}
     */
    this.heroElement = null;
    this.bodyClasses = [`modal-open`];
    this.canPlay = {
      pc: false,
      mb: false,
    };
    this.onPcVideoCanPlay = this.onPcVideoCanPlay.bind(this);
    this.onMbVideoCanPlay = this.onMbVideoCanPlay.bind(this);
    this.onResize = this.onResize.bind(this);
    this.element = {
      figure: null,
    };
    this.onPcVideoPlaying = this.onPcVideoPlaying.bind(this);
    this.onMbVideoPlaying = this.onMbVideoPlaying.bind(this);
    this.playing = {
      pc: false,
      mb: false,
    };
    this.tryPlayCount = {
      pc: 0,
      mb: 0,
    };
    // ---
    // this.onTouchTriggerPlayVideo = this.onTouchTriggerPlayVideo.bind(this);
    // this.touchEvents = [
    //   'touchstart',
    //   'touchmove',
    //   'touchend',
    //   'touchcancel',
    //   'click',
    // ];

    // EPIServerのプレビュー時のモーダルの位置調整
    this.wrapperScrollTop = 0;

  }
  // /**
  //  * touch event を delegate して Android で autoplay できないやつを play する
  //  */
  // onTouchTriggerPlayVideo() {
  //   const video = this.videos.mb;
  //   const playing = this.playing.mb;
  //   if (video && !playing && this.hitTest()) {
  //     // console.log('Video.onTouchTriggerPlayVideo', video.paused, playing);
  //     this.playVideo(false);
  //   }
  // }
  hitTest() {
    const { inHeroCarousel } = this.props;
    return !inHeroCarousel || this.shouldVideoPlay()
  }
  /**
   * `a.HeroVideo__Youtube__link` click event handler
   * - modal open します - state.isOpen: 'is-open'
   * @param {Event} event click Event
   */
  onClickModalOpen(event) {
    event.preventDefault();
    this.executeOpen();
  }

  /**
   * `button.HeroVideo__modal__btn__close` click event handler
   * - modal 閉じます - state.isOpen: ''
   * - YouTube 再生を止めます - `postMessage('{"event":"command","func":"stopVideo","args":""}', '*')`
   * @param {Event} event click Event
   */
  onClickModalClose(event) {
    event.preventDefault();
    this.executeClose();
  }

  /**
   * `div.HeroVideo__modal__content` click handler
   * - modal 閉じます - state.isOpen: ''
   * - YouTube 再生を止めます - `postMessage('{"event":"command","func":"stopVideo","args":""}', '*')`
   * @param {Event} event click Event
   */
  onClickModalCloseByContent(event) {
    const target = event.target;
    // console.log('HeroVideo.onClickModalCloseByContent', target, event);
    const nodeName = target.nodeName.toLowerCase();
    // const className = target.className;
    if (nodeName === 'div' && (target.classList.contains('HeroVideo__modal__content') || target.classList.contains('HeroVideo__modal__content__inner'))) {
      this.executeClose();
    }
  }

  /**
   * modal を開きます
   * - document.body - `.HeroVideo__modal__opened`, `.un-scroll-pc`, `.un-scroll-mb`
   */
  executeOpen() {
    // modal open flag on body
    document.body.classList.add(this.modalOpened);

    // EPIServerのプレビュー時のモーダルの位置調整
    // let isEpiServerPreview = false;
    if (WINDOW && WINDOW.epi && WINDOW.parent) {
      const wrapperElement = WINDOW.parent.document.querySelector("div[data-dojo-attach-point='previewContainer']");
      if (wrapperElement) {
        const wrapperHeight = wrapperElement.clientHeight;
        this.wrapperScrollTop = wrapperElement.scrollTop;
        const iframe = wrapperElement.querySelector('iframe');
        if (iframe) {
          DOCUMENT.body.style.position = 'absolute';
          DOCUMENT.body.style.top = -this.wrapperScrollTop + 'px';
          const headerElement = WINDOW.document.querySelector('header') || null;
          if (headerElement) {
            headerElement.style.zIndex = 0;
          }
          iframe.style.height = wrapperHeight + 'px';
          // isEpiServerPreview = true;
        }
      }
    }
    // if (!isEpiServerPreview) {
    //   // BODYのスクロール無効化
    //   BodyControl.openModal();
    // }

    // BODYのスクロール無効化
    BodyControl.openModal();
    //this.bodyClasses.map(className => (document.body.classList.add(className)));
    // extend
    // @since 2018-07-06
    const { modalWillOpen, containerId, youtubeId } = this.props;
    if (typeof modalWillOpen === 'function') {
      modalWillOpen.call(this, containerId);
    }
    // ---
    // pause video
    this.pauseVideos();
    // ---
    // state change
    this.setState({ isOpen: 'is-open', youtubeId });
  }

  /**
   * modal を閉じ YouTube 再生を止めます
   * - state.isOpen: ''
   * - {@link HeroVideo.stopYouTube}
   */
  executeClose() {
    this.stopYouTube();
    // ---
    document.body.classList.remove(this.modalOpened);

    // EPIServerのプレビュー時のモーダルの位置調整
    if (WINDOW && WINDOW.epi && WINDOW.parent) {
      const wrapperElement = WINDOW.parent.document.querySelector("div[data-dojo-attach-point='previewContainer']");
      if (wrapperElement) {
        const iframe = wrapperElement.querySelector('iframe');
        if (iframe) {
          DOCUMENT.body.style.position = 'static';
          DOCUMENT.body.style.top = 'auto';
          const headerElement = WINDOW.document.querySelector('header') || null;
          if (headerElement) {
            headerElement.style.zIndex = 3000;
          }
          iframe.style.height = DOCUMENT.body.clientHeight + 'px';
          wrapperElement.scrollTop = this.wrapperScrollTop;
        }
      }
    }

    // BODYのスクロール無効化を解除
    BodyControl.closeModal();
    //this.bodyClasses.map(className => (document.body.classList.remove(className)));
    // ---
    // @since 2018-07-06
    const { modalWillClose, containerId, youtubeId } = this.props;
    if (typeof modalWillClose === 'function') {
      modalWillClose.call(this, containerId);
    }
    // ---
    // play video - check can play
    this.afterModalClosePlayVideoIfCan();
    // ---
    // state change
    this.setState({ isOpen: '', youtubeId: null });
  }
  /**
   * modal close 後に video 再生可能(NO ENDED)なら play します
   */
  afterModalClosePlayVideoIfCan() {
    const { pc, mb } = this.ended;
    if (!pc || !mb) {
      clearTimeout(this.timer.pauseRewind);
    }
    if (!pc) {
      this.playVideo(true);
    }
    if (!mb) {
      this.playVideo(false);
    }
  }
  // -----------------------------------------------------
  /**
   * window.onresize event handler - clientRect を再計算します
   * - {@link HeroVideo.getAndSendRectFigureBlock} 実行し可能なら `clientRect` 通知します
   */
  onResize() {
    setTimeout(() => {
      this.getAndSendRectFigureBlock();
    }, 0);
    // this.getAndSendRectFigureBlock();
  }
  sendMessageFigureRect() {
    clearTimeout(this.timer.load);
    clearTimeout(this.timer.figure);
    const { sendMessage, heroCarouselUniqueId } = this.props;
    const { figure } = this.element;
    if (typeof sendMessage !== 'function' || !figure || !heroCarouselUniqueId) {
      return;
    }
    // console.log('HeroVideo.sendMessageFigureRect', heroCarouselUniqueId, figure);
    const rect = figure.getBoundingClientRect();
    sendMessage.call(this, heroCarouselUniqueId, rect);
  }
  waitingExistFigureAndCanPlay() {
    clearTimeout(this.timer.load);
    const { sendMessage } = this.props;
    if (typeof sendMessage !== 'function') {
      return;
    }
    // console.log('HeroVideo.waitingExistFigureAndCanPlay', heroCarouselUniqueId, heroCarouselSlideId);
    const { pc, mb } = this.canPlay;
    const { figure } = this.element;
    if (!pc || !mb || !figure) {
      this.timer.load = setTimeout(() => {
        this.waitingExistFigureAndCanPlay();
      }, 16);
      return;
    }
    this.sendMessageFigureRect();
  }
  /**
   * {@link HeroVideo.element} `clientRect` を取得し通知します
   */
  getAndSendRectFigureBlock() {
    clearTimeout(this.timer.figure);
    const { sendMessage } = this.props;
    if (typeof sendMessage !== 'function') {
      return;
    }
    // console.log('HeroVideo.getAndSendRectFigureBlock', this.props.heroCarouselUniqueId);
    this.timer.figure = setTimeout(() => {
      this.sendMessageFigureRect();
    }, 1000);
    this.waitingExistFigureAndCanPlay();
  }

  // -----------------------------------------------------

  onPcVideoCanPlay() {
    // console.log('HeroCarousel.onPcVideoCanPlay', this.canPlay.pc);
    // 複数回呼び出されるので onetime 保証する
    if (this.canPlay.pc) {
      return;
    }
    this.canPlay.pc = true;
    // this.played.pc = true;
    // ---
    setTimeout(() => {
      this.getAndSendRectFigureBlock();
    }, 0);
    // this.getAndSendRectFigureBlock();
  }

  onMbVideoCanPlay() {
    // console.log('HeroCarousel.onMbVideoCanPlay', this.canPlay.mb);
    // 複数回呼び出されるので onetime 保証する
    if (this.canPlay.mb) {
      return;
    }
    this.canPlay.mb = true;
    // this.played.mb = true;
    // ---
    setTimeout(() => {
      this.getAndSendRectFigureBlock();
    }, 0);
    // this.getAndSendRectFigureBlock();
  }
  /**
   * pc: video.play event handler
   * - played flag true
   */
  onPcVideoPlay() {
    // console.log('HeroVideo.onPcVideoPlay', this.props.heroCarouselUniqueId);
    this.played.pc = true;
    this.playing.pc = true;
  }
  /**
   * mb: video.play event handler
   * - played flag true
   */
  onMbVideoPlay() {
    // console.log('HeroVideo.onMbVideoPlay', this.played);
    this.played.mb = true;
    this.playing.mb = true;
    // this.disposeTouches();
  }
  onPcVideoPlaying() {
    this.playing.pc = true;
  }
  onMbVideoPlaying() {
    // console.log('HeroVideo.onMbVideoPlaying', this.playing);
    this.playing.mb = true;
  }
  /**
   * PC: video ended event handler
   * - {@link HeroVideo.pc.ended} flag true 設定します
   * - loop 設定がない時に rewind します - video.pause() & video.currentTime = 0
   */
  onPcVideoEnded() {
    // video end
    const { pcLoop } = this.props;
    const video = this.videos.pc;
    // console.log('HeroVideo.onPcVideoEnded', pcLoop, video, this.ended, this.posters);
    // video element が存在し loop: false の時に rewind させる
    if (video && !pcLoop) {
      this.ended.pc = true;
      this.pauseVideo(true);
      // 背景に画像がある時のみ video 非表示
      if (this.posters.pc) {
        this.setState({ visiblePc: false });
      } else {
        this.rewindVideo(true);
      }
    }
  }

  /**
   * MB: video ended event handler
   * - {@link HeroVideo.mb.ended} flag true 設定します
   * - loop 設定がない時に rewind します - video.pause() & video.currentTime = 0
   */
  onMbVideoEnded() {
    // video end
    const { mbLoop } = this.props;
    const video = this.videos.mb;
    // console.log('HeroVideo.onMbVideoEnded', mbLoop, video, this.ended);
    // video element が存在し loop: false の時に rewind させる
    if (video && !mbLoop) {
      this.ended.mb = true;
      this.pauseVideo(false);
      // 背景に画像がある時のみ video 非表示
      if (this.posters.mb) {
        this.setState({ visibleMb: false });
      } else {
        this.rewindVideo(false);
      }
    }
  }

  /**
   * button.HeroVideo__btn__scroll click event handler
   * - link.href から hash を取り出します
   * - {@link scrollToNode} で smooth scroll させます
   * - `.hero` 見切れるまで移動します
   * @param {Event} event click event - `preventDefault` します
   */
  onClickInnerLink(event) {
    event.preventDefault();
    // resize 時の移動位置がおかしくなる(scrollToNode bug?)ので毎回新規に取得する
    const heroElement = document.querySelector('.hero');
    if (heroElement) {
      this.heroElement = heroElement;
      const rect = heroElement.getBoundingClientRect();
      // console.log('HeroVideo.onClickInnerLink', rect);
      const option = {
        duration: 480,
        offset: rect.height,
      };
      scrollToNode(heroElement, option);
      this.enableButtonScrollEffect();
    }
  }

  enableButtonScrollEffect() {
    // clearTimeout(this.timer.btnScroll);
    clearTimeout(this.timer.btnEmpty);
    const delay = this.state.btnScrollClicked ? 16: 0;
    if (delay) {
      this.setState({ btnScrollClicked: '' });
    }
    this.timer.btnEmpty = setTimeout(() => {
      this.delayDisposeButtonScrollEffect();
    }, delay);
  }

  delayDisposeButtonScrollEffect() {
    clearTimeout(this.timer.btnScroll);
    this.setState({ btnScrollClicked: 'HeroVideo__btn__scroll__clicked' });
    this.timer.btnScroll = setTimeout(() => {
      this.setState({ btnScrollClicked: '' });
    }, 1750);
  }

  /**
   * imageLink enter event handler
   * - `.ImageLink__entered` class 追加
   */
  onLinkEnter() {
    this.setState({ entered: 'ImageLink__entered' });
  }

  /**
   * imageLink leave event handler
   * - `.ImageLink__entered` class 削除
   */
  onLinkLeave() {
    this.setState({ entered: '' });
  }

  /**
   * 関連動画 click delegate event handler
   * @param {Event} event click Event
   */
  onClickRelated(event) {
    const target = event.target;
    const youtubeId = HeroVideo.parseNode(target);
    // console.log('HeroVideo.onClickRelated', youtubeId, target);
    if (youtubeId) {
      this.setState({youtubeId});
    } else {
      this.executeClose();
    }
  }

  /**
   * YouTube modal 閉じる時に再生を止めます
   */
  stopYouTube() {
    const player = this.youtubeIframe;
    // console.log('HeroVideo.onClickModalClose', player);
    if (!player) {
      return;
    }
    try {
      player.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
    } catch (error) {
      console.warn('HeroVideo.stopYouTube', error);
      // postMessage - 実行できないときは iframe src を空にして無理やり止める
      this.youtubeIframeSrc = player.src;
      player.src = '';
    }
  }

  /**
   * window size から pc / mb どちらのモードかを調べます
   * @returns {{pc: boolean, mb: boolean}} 真偽値として返します
   */
  size() {
    const width = window.innerWidth;
    const breakPoint = this.breakPoint;
    return {
      pc: width >= breakPoint,
      mb: width < breakPoint,
    };
  }

  /**
   * HTML5 video pause します
   * @param {boolean} pc video file select flag - true: PC
   * @param {?function} [func=null] pause 後に実行する関数
   */
  pauseVideo(pc, func = null) {
    const played = (pc) ? this.played.pc: this.played.mb;
    if (!played) {
      return;
    }
    if (pc) {
      clearTimeout(this.timer.checkPlayingPc);
    } else {
      clearTimeout(this.timer.checkPlayingMb);
    }
    const videos = this.videos;
    const video = (pc) ? videos.pc: videos.mb;
    const { visiblePc, visibleMb } = this.state;
    const visible = (pc) ? visiblePc: visibleMb;

    if (!video || !visible) {
      return;
    }
    // status check - 2018-10-31
    if (video.paused) {
      return;
    }
    // console.log('HeroVideo.pauseVideo ---------', this.props.heroCarouselUniqueId, pc, visible, video.src);
    try {
      video.pause();
    } catch (e) {
      console.warn('[HeroVideo] - pauseVideo - error', e);
    }

    if (func) {
      func.call(this, !pc);
    }
    // if (pc) {
    //   this.played.pc = false;
    // } else {
    //   this.played.mb = false;
    // }
  }
  // checkPlayingPc(noHideVideo = false) {
  //   this.tryPlayCount.pc += 1;
  //   clearTimeout(this.timer.playingPc);
  //   if (this.tryPlayCount.pc <= 30) {
  //     if (!this.playing.pc) {
  //       this.timer.playingPc = setTimeout(() => {
  //         this.playVideo(true);
  //       }, 16);
  //     }
  //   } else if (!noHideVideo) {
  //     this.hideVideoTag(true);
  //   }
  // }
  // checkPlayingMb(noHideVideo = false) {
  //   this.tryPlayCount.mb += 1;
  //   // console.log('HeroVideo.checkPlayingMb', this.props.heroCarouselUniqueId, this.tryPlayCount.mb, this.playing.mb);
  //   clearTimeout(this.timer.playingMb);
  //   if (this.tryPlayCount.mb <= 30) {
  //     if (!this.playing.mb) {
  //       this.timer.playingMb = setTimeout(() => {
  //         this.playVideo(false);
  //       }, 32);
  //     }
  //   } else if (!noHideVideo) {
  //     // console.log('HeroVideo.checkPlayingMb - noHideVideo', this.props.heroCarouselUniqueId, this.tryPlayCount.mb, this.playing.mb);
  //     this.hideVideoTag(false);
  //   }
  // }
  hideVideoTag(pc) {
    if (pc) {
      if (this.state.visiblePc) {
        this.setState({ visiblePc: false });
      }
    } else if (this.state.visibleMb) {
      this.setState({ visibleMb: false });
    }
  }
  // -----------------------------------------------------
  delayCheckPlayingAfterSuccess(pc) {
    if (pc) {
      clearTimeout(this.timer.checkPlayingPc);
      this.tryPlayCount.pc = 0;
      this.timer.checkPlayingPc = setTimeout(() => {
        this.checkPlayingPc(true);
      }, 500);
    } else {
      clearTimeout(this.timer.checkPlayingMb);
      this.tryPlayCount.mb = 0;
      this.timer.checkPlayingMb = setTimeout(() => {
        this.checkPlayingMb(true);
      }, 500);
    }
  }
  // -----------------------------------------------------
  /**
   * video.play success 処理
   * - played flag true
   * @param {boolean} pc video file select flag - true: PC
   */
  playSuccess(pc) {
    if (pc) {
      this.played.pc = true;
      // this.delayCheckPlayingAfterSuccess(true);
    } else {
      this.played.mb = true;
      // this.delayCheckPlayingAfterSuccess(false);
    }
  }
  needHideVideo(pc, error) {
    if (!error) {
      return false;
    }
    // 404: ~ no supported source ~
    // touch first: failed because the user didn't interact with the document first
    const massages = [
      'no supported source',
      'interact width',
    ];
    const result = massages.some(message => (error.message.indexOf(message) !== -1));
    if (result) {
      const state = pc ? { visiblePc: false } : { visibleMb: false };
      this.setState(state);
      return true;
    }
    return false;
  }

  /**
   * {@link HeroVideo.needHideVideo} - error message より　｀ヴィデオ｀非表示実行します
   * - no supported source - 404, ...etc
   * - didn't interact - have to touch
   * 戻り値 `false` - 非表示にならない時は 1frame に移動して止める
   * @param {boolean} pc video file select flag - true: PC
   * @param {string} [error=''] video play error message
   */
  playFaultAlternateImage(pc, error = '') {
    // console.log('Video.playFaultAlternateImage', pc, this.posters);
    if (this.needHideVideo(pc, error)) {
      return;
    }

    this.pauseVideo(pc);
    this.rewindVideo(pc);
  }
  /**
   * video.play fault 処理
   * - {@link HeroVideo.playFaultAlternateImage} - error message により `video` 非表示判断します
   * @param {boolean} pc video file select flag - true: PC
   * @param {string} [error=''] video play error message
   */
  playFault(pc, error = '') {
    this.playFaultAlternateImage(pc, error);
  }

  /**
   * HTML5 video start します
   * @param {boolean} pc video file select flag - true: PC
   * @param {?function} [func=null] play resolve function - play 実行後に実行します
   */
  playVideo(pc, func = null) {
    const videos = this.videos;
    const video = (pc) ? videos.pc: videos.mb;
    // const played = (pc) ? this.played.pc : this.played.mb;
    const ended = pc ? this.ended.pc : this.ended.mb;
    const { visiblePc, visibleMb } = this.state;
    const visible = (pc) ? visiblePc: visibleMb;
    // console.log('HeroVideo.playVideo --------- ', this.props.heroCarouselUniqueId, pc, video.src, visible, ended);
    if (!video || !visible || ended) {
      if (func) {
        func.call(this, pc)
      }
      return;
    }
    // ---
    if (!video.paused) {
      if (func) {
        func.call(this, pc)
      }
      return;
    }
    // ---
    let playPromise = null;
    try {
      playPromise = video.play();
      this.playSuccess(pc);
    } catch (e) {
      console.warn(`[HeroVideo] play video fault - pc: ${pc}, ${error}`, video.src);
      this.playFault(pc, e)
    }
    if (playPromise) {
      playPromise.then(() => {
          // sequence function execute
          this.playSuccess(pc);
        })
        .catch((error) => {
          console.warn(`[HeroVideo] play video fault in Promise - pc: ${pc}, ${error}`, video.src);
          this.playFault(pc, error)
        });
    }
    if (func) {
      func.call(this, pc)
    }
  }

  /**
   * rewind します
   * @param {boolean} pc video file select flag - true: PC
   */
  rewindVideo(pc) {
    const videos = this.videos;
    const video = (pc) ? videos.pc: videos.mb;
    const { visiblePc, visibleMb } = this.state;
    const visible = (pc) ? visiblePc: visibleMb;
    if (!video || !visible) {
      return;
    }
    // 再生中は rewind しない
    if (!video.paused) {
      return;
    }
    // console.log('HeroVideo.rewindVideo', pc, visible);
    try {
      video.currentTime = 0;
    } catch (error) {
      console.warn('[HeroVideo].rewindVideo', pc, video.src, error);
    }
    // if (pc) {
    //   this.video.pc = false;
    // } else {
    //   this.video.mb = false;
    // }
  }

  // waitPlayVideoUntilCanPlayPc() {
  //   clearTimeout(this.timer.waitPc);
  //   const { visiblePc } = this.state;
  //   if (!visiblePc) {
  //     return;
  //   }
  //   // console.log('HeroVideo.waitPlayVideoUntilCanPlayPc', visiblePc, this.canPlay.pc);
  //   if (!this.canPlay.pc) {
  //     this.timer.waitPc = setTimeout(() => {
  //       this.waitPlayVideoUntilCanPlayPc();
  //     }, 16);
  //     return;
  //   }
  //   // pc
  //   this.playVideo(true);
  // }

  // waitPlayVideoUntilCanPlayMb() {
  //   clearTimeout(this.timer.waitMb);
  //   const { visibleMb } = this.state;
  //   if (!visibleMb) {
  //     return;
  //   }
  //   // console.log('HeroVideo.waitPlayVideoUntilCanPlayMb', this.props.heroCarouselUniqueId, this.canPlay.mb);
  //   if (!this.canPlay.mb) {
  //     // can play になるまで待機します
  //     this.timer.waitMb = setTimeout(() => {
  //       this.waitPlayVideoUntilCanPlayMb();
  //     }, 16);
  //     return;
  //   }
  //   // ---
  //   // mb
  //   this.playVideo(false);
  // }

  // waitPlayVideosUntilCanPlay() {
  //   clearTimeout(this.timer.pauseRewind);
  //   this.waitPlayVideoUntilCanPlayPc();
  //   this.waitPlayVideoUntilCanPlayMb();
  // }

  /**
   * 動画再生を行う - {@link HeroVideo.playVideo}
   */
  playVideos() {
    clearTimeout(this.timer.pauseRewind);
    this.playVideo(true);
    this.playVideo(false);
  }

  /**
   * 動画再生停止を行う - {@link HeroVideo.pauseVideo}
   */
  pauseVideos() {
    clearTimeout(this.timer.pauseRewind);
    // console.log('HeroVideo.pauseVideos ----', this.props.heroCarouselUniqueId);
    // pc
    this.pauseVideo(true);
    // mb
    this.pauseVideo(false);
  }

  rewindVideos() {
    clearTimeout(this.timer.pauseRewind);
    // console.log('HeroVideo.rewindVideos ====', this.props.heroCarouselUniqueId);
    // pc
    this.rewindVideo(true);
    // mb
    this.rewindVideo(false);
  }

  /**
   * video mute を実行します
   */
  muteVideos() {
    // react video.muted bug ?
    // @see https://github.com/facebook/react/blob/1c2876d5b558b8591feb335d8d7204bc46f7da8a/packages/react-dom/src/shared/DOMProperty.js#L312
    // video muted attribute を追加する
    // not work `setAttribute` - muted="muted", muted="true"
    Object.values(this.videos).map(video => {
      if (video) {
        video.muted = true;
        video.defaultMuted = true;
      }
      return video;
    });
  }

  delayPauseAndRewind(delay = 160) {
    clearTimeout(this.timer.pauseRewind);
    this.timer.pauseRewind = setTimeout(() => {
      this.pauseVideos();
      this.rewindVideos();
    }, delay);
  }

  // -----------------------------------------------
  /**
   * video tag 存在 flag
   * @returns {boolean} true: exist
   */
  hasVideo() {
    return Object.values(this.videos).some(video => (video !== null));
  }

  // -----------------------------------------------
  /**
   * YouTube iframe src path を作成します
   * @param {string} id YouTibe ID
   * @returns {string} `//www.youtube.com/embed/${id}?rel=0&version=3&enablejsapi=1`
   */
  createPath(id) {
    const path = id ? `//www.youtube.com/embed/${id}?rel=0&showinfo=0&version=3&enablejsapi=1` : '';
    this.youtubeIframeSrc = path;
    return path;
  }

  // -----------------------------------------------
  /**
   * same id check - HeroCarousel 内の時 video 再生行うかを判定します
   * @returns {boolean} true -> will video play
   */
  shouldVideoPlay() {
    const { heroCarouselSlideId, heroCarouselUniqueId } = this.props;
    return heroCarouselSlideId === heroCarouselUniqueId
  }

  // -----------------------------------------------
  checkVideoPlaying(delay = 1000) {
    clearTimeout(this.timer.firstVideoPlay);
    // console.log('HeroVideo.checkVideoPlaying - 1000', this.playing);
    this.timer.firstVideoPlay = setTimeout(() => {
      this.playVideos();
    }, delay);
  }
  // -----------------------------------------------
  // disposeTouches() {
  //   this.touchEvents.map(type => (window.removeEventListener(type, this.onTouchTriggerPlayVideo)));
  // }
  // -----------------------------------------------
  /**
   * delegate update
   * - modal close && props.heroCarouselSlideId === props.heroCarouselUniqueId の時に play video します
   * - else -> video pause and rewind します
   * @param {*} prevProps previous props
   */
  componentDidUpdate(prevProps) {
    const {
      isOpen,
    } = this.state;
    // console.log('HeroVideo.componentDidUpdate derivedStateFromProps', heroCarouselUniqueId, heroCarouselSlideId, this.state.heroCarouselSlideId);
    // flag 変更されたときのみ message 送信する
    if (prevProps.requestMessageFlag !== this.props.requestMessageFlag) {
      setTimeout(() => {
        this.getAndSendRectFigureBlock();
      }, 0);
    }
    if (isOpen) {
      return;
    }
    if (this.shouldVideoPlay()) {
      // console.log('HeroVideo.componentDidUpdate shouldVideoPlay', this.shouldVideoPlay(), this.state.heroCarouselSlideId);
      setTimeout(() => {
        this.playVideos();
      }, 0);
    } else {
      const { heroCarouselSlideId, heroCarouselUniqueId } = prevProps;
      const delay = heroCarouselSlideId === heroCarouselUniqueId ? 160: 0;
      this.delayPauseAndRewind(delay);
    }
  }

  /**
   * delegate after mount
   * - played
   */
  componentDidMount() {
    setTimeout(() => {
      this.muteVideos();
    }, 0);
    // ---
    const { inHeroCarousel } = this.props;
    if (inHeroCarousel && !this.shouldVideoPlay()) {
      // in HeroCarousel && myId と currentId を比較し異なる時に pause する
      setTimeout(() => {
        this.pauseVideos();
      }, 0);
    } else {
      // Android 6 - cant work autoplay + touch require
      // this.checkVideoPlaying(0);
      this.playVideos();
    }
    // hero carousel child 時に resize watch
    if (inHeroCarousel) {
      window.addEventListener('resize', this.onResize, false);
    }
    // // ---
    // // Android `NotAllowedError: play() failed because the user didn't interact with the document first.` の対策で touch 監視して再生させる
    // if (this.videos.mb && 'ontouchstart' in document.documentElement) {
    //   this.touchEvents.map(type => (window.addEventListener(type, this.onTouchTriggerPlayVideo, false)));
    // }
  }

  componentWillUnmount() {
    Object.values(this.timer).map(id => (clearTimeout(id)));
    window.removeEventListener('resize', this.onResize);
    // this.disposeTouches();
  }

  // -----------------------------------------------
  /**
   * props `imageLink` と `link` 値をもとに - Hero全体でリンク設定するか否かのためのコンテナを作成します
   * - HeroVideoRoot - `a` or `div`
   * - attributes - HeroVideoRoot 属性
   * a 設定時に必要な属性を `attributes` に追加します
   * @returns {?Element} Hero全体でリンク設定するか否かのためのコンテナを返します
   */
  renderImageLink() {
    const {imageLink, link, youtubeId} = this.props;
    // imageLink 設定なし
    if (imageLink === null || !imageLink) {
      return null;
    }
    // youtubeId - 存在する時は設定無い
    if (youtubeId !== null && youtubeId) {
      return null;
    }
    // link check
    // imageLink の設定有り, link property illegal なので出力しない
    if (link === null || !link.href) {
      return null;
    }
    // type を className へ
    const type = link.type || '';
    return (
      <a
        className={`HeroVideo__imageLink ${type}`}
        href={link.href}
        target={(link.targetBlank) ? '_blank': '_self'}
        onMouseEnter={this.onLinkEnter}
        onMouseLeave={this.onLinkLeave}
      />
    );
  }

  // -----------------------------------------------
  /**
   * YouTube modal link 作成します - `a.HeroVideo__Youtube__link`
   * @returns {?Element} `a.HeroVideo__Youtube__link`
   */
  renderYoutubeLink() {
    const {youtubeId, link} = this.props;
    if (youtubeId === null || !youtubeId) {
      return null;
    }
    // modal open
    // type を className へ
    const type = link.type || '';
    return <a
      href="#"
      className={`HeroVideo__Youtube__link ${type}`}
      onClick={this.onClickModalOpen}
    />;
  }
  /**
   * button.HeroVideo__btn__scroll Element を作成します
   * - click -> onClickInnerLink -> {@link scrollToElementId}
   * @returns {?Element} button.HeroVideo__btn__scroll
   */
  renderButtonScroll() {
    const {
      scrollToSlug,
    } = this.props;
    // hash
    const id = this.targetId;
    // require check
    if (scrollToSlug === null) {
      return null;
    }
    const {btnScrollClicked} = this.state;
    // output
    return (
      <button
        className={`HeroVideo__btn__scroll ${btnScrollClicked}`}
        type="button"
        onClick={this.onClickInnerLink}
        data-target={id}
      >
        <i/>
      </button>
    );
  }
  /**
   * `div.HeroVideo__heading` section 作成します
   * - preHeading
   * - heading
   * - description
   * @returns {?Element} `div.HeroVideo__heading` を返します
   */
  renderHeading() {
    const {
      pcPreHeading,
      mbPreHeading,
      preHeadingTag,
      pcHeading,
      mbHeading,
      headingTag,
      pcDescription,
      mbDescription,
    } = this.props;
    // ---
    const alternate = {
      heading: pcHeading,
      pre: pcPreHeading,
      description: pcDescription,
    };
    // ---
    const tags = {
      pcPre: <HeadingTag
        tag={preHeadingTag}
        label={pcHeading}
        defaultTagName="h3"
        suffix="pcPreHeading"
        dangerous
      />,
      pcHead: <HeadingTag
        tag={headingTag}
        label={mbHeading}
        defaultTagName="h2"
        suffix="mbHeading"
        dangerous
      />,
      mbPre: <HeadingTag
        tag={preHeadingTag}
        label={mbPreHeading}
        defaultTagName="h3"
        suffix="mbPreHeading"
        dangerous
        alternate={alternate.pre}
      />,
      mbHead: <HeadingTag
        tag={headingTag}
        label={mbHeading}
        defaultTagName="h2"
        suffix="mbHeading"
        dangerous
        alternate={alternate.heading}
      />,
      pcDescription: <DescriptionTag
        description={pcDescription}
        suffix="pcDescription"
      />,
      mbDescription: <DescriptionTag
        description={mbDescription}
        suffix="mbDescription"
        alternate={alternate.description}
      />,
      // pcPre: HeroVideo.headingTag(preHeadingTag, pcPreHeading, 'h3', 'pcPreHeading', true),
      // pcHead: HeroVideo.headingTag(headingTag, pcHeading, 'h2', 'pcHeading', true),
      // mbPre: HeroVideo.headingTag(preHeadingTag, mbPreHeading, 'h3', 'mbPreHeading', true, alternate.pre),
      // mbHead: HeroVideo.headingTag(headingTag, mbHeading, 'h2', 'mbHeading', true, alternate.heading),
      // pcDescription: HeroVideo.descriptionTag(pcDescription, 'pcDescription'),
      // mbDescription: HeroVideo.descriptionTag(mbDescription, 'mbDescription', alternate.description),
    };
    // null 以外を check
    const hasTag = Object.values(tags).some(tag => (tag !== null));
    if (!hasTag) {
      // 全て null なので処理しない
      return null;
    }
    // tag exist
    return (
      <div className="HeroVideo__heading">
        {tags.pcPre}
        {tags.mbPre}
        {tags.pcHead}
        {tags.mbHead}
        {tags.pcDescription}
        {tags.mbDescription}
      </div>
    );
  }

  /**
   * `div.HeroVideo__container` section 作成します
   * - pcPosition / mbPosition から css class 作成し設定します
   * - pcTextAlign / mbTextAlign から css class 作成し設定します
   * - {@link HeroVideo.renderHeading}
   * - {@link HeroVideo.renderButtonScroll}
   * - mb - CTA
   * @returns {?Element} `div.HeroVideo__container` を返します
   */
  renderContainer() {
    const {
      pcPosition,
      mbPosition,
      // imageLink,
      pcTextAlign,
      mbTextAlign,
      link,
      youtubeId,
    } = this.props;
    // ---
    const heading = this.renderHeading();
    // buttons
    // // scroll
    // const buttonScroll = this.buttonScroll();
    // 仕様変更 - VideoIDが設定されていた場合、CTAボタンは非表示としてください。
    const cta = !youtubeId ? <CtaTag link={link} /> : null;
    // const cta = !youtubeId ? HeroVideo.ctaTag(link): null;
    // output
    if (!heading && !cta) {
      return null;
    }
    // positions
    const positions = {
      pc: (pcPosition !== null && pcPosition) ? pcPosition.toLowerCase() : '',
      mb: (mbPosition !== null && mbPosition) ? `${mbPosition.toLowerCase()}-mb` : '',
    };
    const ctaClassName = (cta) ? 'has-btn__link': '';
    // align
    const alignPc = (pcTextAlign !== null && pcTextAlign) ? `align-${pcTextAlign.toLowerCase()}-pc` : '';
    const alignMb = (mbTextAlign !== null && mbTextAlign) ? `align-${mbTextAlign.toLowerCase()}-mb` : '';
    // tag exist
    return (
      <div
        className={`HeroVideo__container ${positions.pc} ${positions.mb} ${ctaClassName} ${alignPc} ${alignMb}`}
      >
        {heading}
        {cta}
      </div>
    );
  }

  /**
   * HTML5 video tag を作成します
   * @param {?string} src video path
   * @param {?boolean} loop loop flag
   * @param {?string} [poster=null] poster image path
   * @param {string} [suffix=''] `baseClass` の末尾に追加する文字 `-` 連結します
   * @param {string} [baseClass=HeroVideo__video] コンテナへ付与する class name 先頭文字
   * @returns {?Element} `video.HeroVideo__video` tag を返します
   */
  renderVideoTag(src, loop, poster = null, suffix = '', baseClass = 'HeroVideo__video') {
    // 制御に必要な property が無い時は null を返す
    if (src === null || !src || !suffix) {
      return null;
    }
    // state - visible
    const { visiblePc, visibleMb } = this.state;
    const isPc = (suffix === 'pc');
    const visible = isPc ? visiblePc : visibleMb;
    if (!visible) {
      if (isPc) {
        this.videos.pc = null;
      } else {
        this.videos.mb = null;
      }
      return null;
    }
    // class name
    const className = `${baseClass}${(suffix) ? '-': ''}${suffix}`;
    // video tag
    const attributes = {
      preload: 'none',
      controls: false,
      // autoPlay: true にしないと onCanPlay 発火しない
      // autoPlay: true,
      // @since 2018-07-06
      // in HeroCarousel auto play させない <- 仕様変更に伴い false 変更する
      // autoPlay: false,
      playsInline: true,
      // not work - react bug?
      muted: true,
      // custom
      loop: !!loop,
      src,
      className,
      type: `video/${src.split('.').pop().split('?').shift()}`,
    };
    // poster 存在する時のみ
    if (poster) {
      attributes.poster = poster;
    }
    // pc / mb
    // onEnded event と ref を分けるために分岐処理する
    // - autoPlay で play させて resize 制御しないことにする
    // 基本 auto play - HeroCarousel - didMount で pause させる
    if (isPc) {
      // ---
      // autoPlay
      attributes.autoPlay = visiblePc;
      // ---
      attributes.ref = (component) => (this.videos.pc = component);
      attributes.onEnded = this.onPcVideoEnded;
      attributes.onPlay = this.onPcVideoPlay;
      attributes.onCanPlay = this.onPcVideoCanPlay;
      attributes.onPlaying = this.onPcVideoPlaying;
      attributes.style = (visiblePc) ? null: { display: 'none' };
    } else {
      // ---
      // autoPlay
      attributes.autoPlay = visibleMb;
      // ---
      attributes.ref = (component) => (this.videos.mb = component);
      attributes.onEnded = this.onMbVideoEnded;
      attributes.onPlay = this.onMbVideoPlay;
      attributes.onCanPlay = this.onMbVideoCanPlay;
      attributes.onPlaying = this.onMbVideoPlaying;
      attributes.style = (visibleMb) ? null: { display: 'none' };
    }
    // tag
    return <video {...attributes} />;
  }

  /**
   * {@link PhotoInfo} props 拡張し render する
   * @returns {?Array<?ReactElement>} `PhotoInfo` list
   */
  renderPhotoInfoContainer() {
    const {
      photoInfo,
      containerId,
      photoInfoWillOpen,
      photoInfoWillClose,
      inHeroCarousel,
      heroCarouselSlideId,
    } = this.props;
    // console.log('HeroVideo.photoInfoContainer', heroCarouselSlideId, this.state.heroCarouselSlideId);
    // photoInfo - arrayOf だけど出力は1件
    const photoInfoList = (photoInfo !== null && Array.isArray(photoInfo) && photoInfo.length) ? photoInfo: [];
    // PhotoInfo.props extends
    return photoInfoList.map((child, index) => {
      // console.log('HeroImage.photoInfoContainer.map', child, child.type.displayName);
      return (child.type.displayName === 'PhotoInfo') ?
        <PhotoInfo
          key={`PhotoInfo-${child.props.containerId}-${index}`}
          {...child.props}
          parentComponentName="HeroVideo"
          parentComponentId={containerId}
          photoInfoWillOpen={photoInfoWillOpen}
          photoInfoWillClose={photoInfoWillClose}
          inHeroCarousel={inHeroCarousel}
          heroCarouselSlideId={heroCarouselSlideId}
        />: null;
    });
  }

  /**
   * `div.HeroVideo__figure__block`
   * - video figure container を作成します
   * @returns {?Element} `div.HeroVideo__figure__block`
   */
  renderFigureVideo() {
    const {
      pcVideoSrc,
      mbVideoSrc,
      pcVideoFilter,
      mbVideoFilter,
      pcLoop,
      mbLoop,
      pcSrc,
      mbSrc,
      // photoInfo,
    } = this.props;
    // ---
    if (pcVideoSrc === null || !pcVideoSrc) {
      return null;
    }
    // ---
    const mobileVideo = mbVideoSrc || pcVideoSrc;
    const mobilePoster = mbSrc || pcSrc;
    // ---
    const pcVideo = this.renderVideoTag(pcVideoSrc, pcLoop, pcSrc, 'pc');
    const mbVideo = this.renderVideoTag(mobileVideo, mbLoop, mobilePoster, 'mb');
    // ---
    const { visiblePc, visibleMb } = this.state;
    const pcPoster = <LikeVideoPosterBackground
      src={pcSrc}
      suffix="pc"
      videoVisible={visiblePc}
    />;
    const mbPoster = <LikeVideoPosterBackground
      src={mobilePoster}
      suffix="mb"
      videoVisible={visibleMb}
    />;
    // ---
    if (!pcVideo && !mbVideo && !pcPoster && !mbPoster) {
      return null;
    }
    // ---
    this.posters.pc = !!pcSrc;
    this.posters.mb = !!mobilePoster;
    // console.log('HEroVideo.renderFigureVideo', this.posters, pcSrc, mobilePoster, pcPoster, mbPoster);
    // ---
    // filter
    const pcFilter = <FilterTag filterFlag={pcVideoFilter} suffix="pc" />;
    const mbFilter = <FilterTag filterFlag={mbVideoFilter} suffix="mb" />;
    // ---
    // youtube modal trigger
    const youtubeLink = this.renderYoutubeLink();
    // ---
    // large link
    const imageLink = (!youtubeLink) ? this.renderImageLink(): null;
    // ---
    // scroll
    const buttonScroll = this.renderButtonScroll();
    // ---
    // photoInfo
    // photoInfo - arrayOf だけど出力は1件
    const photoInfoList = this.renderPhotoInfoContainer();
    // output
    return (
      <div
        className="HeroVideo__figure__block"
        ref={component => (this.element.figure = component)}
      >
        <div className="HeroVideo__video__block" data-hero-movie={(this.props.youtubeId) ? this.props.youtubeId : ''}>
          {pcVideo}
          {mbVideo}
          {pcPoster}
          {mbPoster}
        </div>
        {pcFilter}
        {mbFilter}
        {youtubeLink}
        {imageLink}
        {photoInfoList}
        {buttonScroll}
      </div>
    );
  }

  /**
   * `div.HeroVideo__figure__block`
   * - video figure container を作成します
   * @returns {?Element} `div.HeroVideo__figure__block`
   */
  renderFigureImage() {
    const {
      pcVideoFilter,
      mbVideoFilter,
      pcSrc,
      mbSrc,
      // photoInfo,
    } = this.props;
    // ---
    if (pcSrc === null || !pcSrc) {
      return null;
    }
    // ---
    const mobilePoster = mbSrc || pcSrc;
    // ---
    const pcPoster = <LikeVideoPosterBackground
      src={pcSrc}
      suffix="pc"
      videoVisible={false}
    />;
    const mbPoster = <LikeVideoPosterBackground
      src={mobilePoster}
      suffix="mb"
      videoVisible={false}
    />;
    // ---
    if (!pcPoster && !mbPoster) {
      return null;
    }
    // ---
    // filter
    const pcFilter = <FilterTag filterFlag={pcVideoFilter} suffix="pc" />;
    const mbFilter = <FilterTag filterFlag={mbVideoFilter} suffix="mb" />;
    // ---
    // youtube modal trigger
    const youtubeLink = this.renderYoutubeLink();
    // ---
    // large link
    const imageLink = (!youtubeLink) ? this.renderImageLink(): null;
    // ---
    // scroll
    const buttonScroll = this.renderButtonScroll();
    // ---
    // photoInfo
    // photoInfo - arrayOf だけど出力は1件
    const photoInfoList = this.renderPhotoInfoContainer();
    // output
    return (
      <div
        className="HeroVideo__figure__block"
        ref={component => (this.element.figure = component)}
      >
        <div className="HeroVideo__video__block" data-hero-movie={(this.props.youtubeId) ? this.props.youtubeId : ''}>
          {pcPoster}
          {mbPoster}
        </div>
        {pcFilter}
        {mbFilter}
        {youtubeLink}
        {imageLink}
        {photoInfoList}
        {buttonScroll}
      </div>
    );
  }

  /**
   * YouTube modal 関連動画 - `div.HeroVideo__modal__relatedVideos`
   * @returns {?Element} `div.HeroVideo__modal__relatedVideos`
   */
  renderRelatedVideo() {
    const { relatedVideo } = this.props;
    if (relatedVideo === null || !Array.isArray(relatedVideo) || !relatedVideo.length) {
      return null;
    }
    // truncate 5
    if (relatedVideo.length > 5) {
      relatedVideo.length = 5;
    }
    return (
      <div
        className="RelatedVideo__container"
        role="presentation"
        onClick={this.onClickRelated}
      >
        <h3 className="RelatedVideo__main_title">関連動画</h3>
        <div className="RelatedVideo__wrap">
          {
            // 保険 - component 保証する
            relatedVideo.map((component, index) => {
              const id = `HeroVideo-relatedVideo-${index}`;
              return <RelatedVideo key={id} {...component.props} />;
            })
          }
        </div>
      </div>
    );
  }

  /**
   * YouTube 再生するための modal container - `div.HeroVideo__modal`
   * - YouTube iframe API 使用する
   * - `postMessage` を使用し control します `//www.youtube.com/embed/` - `embed` 必須 not `v`
   * - `enablejsapi=1` 必須
   * - {@link HeroVideo.youtubeIframe} へ iframe 参照を保存します
   * @returns {?Element} `div.HeroVideo__modal`
   * @see https://developers.google.com/youtube/iframe_api_reference?hl=ja
   */
  renderModal() {
    const { youtubeId } = this.state;
    // if (youtubeId === null || !youtubeId) {
    //   return null;
    // }
    // ---
    // unique id - control する時に識別子として必要になるかもなので念のために設定する
    const id = this.youtubeIframeId;
    // ---
    // const src = this.youtubeIframeSrc || `//www.youtube.com/embed/${youtubeId}?rel=0&version=3&enablejsapi=1`;
    // ---
    const src = this.createPath(youtubeId);
    // ---
    return (
      <div className={`HeroVideo__modal ${this.state.isOpen}`}>
        <div
          className="HeroVideo__modal__overlay"
          role="presentation"
          onClick={this.onClickModalClose}
        />
        <div
          className="HeroVideo__modal__content"
          onClick={this.onClickModalCloseByContent}
        >
          <div
            className="HeroVideo__modal__content__inner"
            onClick={this.onClickModalCloseByContent}
          >
            <div className="HeroVideo__modal__movie__block">
              {(()=> {
                if (this.state.isOpen) {
                  return (
                    <YoutubePlayer
                      cls="HeroVideo__modal__movie"
                      height={'100%'}
                      width={'100%'}
                      autoplay={1}
                      controls={1}
                      youtubeId={youtubeId}
                      isModal={true}
                    />
                  )
                }
              })()}
              {/*<YoutubePlayer*/}
              {/*  cls="HeroVideo__modal__movie"*/}
              {/*  height={'100%'}*/}
              {/*  width={'100%'}*/}
              {/*  autoplay={1}*/}
              {/*  // autoplay={0}*/}
              {/*  controls={1}*/}
              {/*  youtubeId={youtubeId}*/}
              {/*/>*/}
              {/*<iframe*/}
                {/*id={id}*/}
                {/*src={src}*/}
                {/*frameBorder="0"*/}
                {/*className="HeroVideo__modal__movie"*/}
                {/*allow="autoplay; encrypted-media"*/}
                {/*allowFullScreen={true}*/}
                {/*ref={component => (this.youtubeIframe = component)}*/}
              {/*/>*/}
            </div>
            {this.renderRelatedVideo()}
          </div>
        </div>
        <a
          className="HeroVideo__modal__btn__close"
          onClick={this.onClickModalClose}
        />
      </div>
    );
  }

  /**
   * `div.HeroVideo` 作成します
   * @returns {?Element} `div.HeroVideo`
   */
  render() {
    const {
      containerId,
      containerClass,
      pcSize,
      mbSize,
      scrollToSlug,
    } = this.props;
    // ---
    // figure
    // figureImage - YouTube only - figureVideo(background video) 優先 - 共存しない
    const figureVideo = this.renderFigureVideo();
    // const figureImage = (!figureVideo) ? this.figure(): null;
    const figureImage = (!figureVideo) ? this.renderFigureImage(): null;
    // ---
    // container
    const container = this.renderContainer();
    // ---
    // 出力対象存在チェック
    if (!figureVideo && !figureImage && !container) {
      return null;
    }
    // ---
    const { entered } = this.state;
    // ---
    // modal - trigger
    const youtubeModal = this.renderModal();
    // ---
    // size setting
    const sizePc = (pcSize !== null && pcSize) ? `${pcSize.toLowerCase()}Size-pc`: '';
    const sizeMb = (mbSize !== null && mbSize) ? `${mbSize.toLowerCase()}Size-mb`: '';
    // ---
    // visible class
    const visible = !!scrollToSlug ? 'is-show-scroll_btn': 'is-hide-scroll_btn';
    // ---
    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
      >
        <article className="HeroVideo__article">
          <section className={`HeroVideo ${sizePc} ${sizeMb} ${visible} ${entered}`}>
            {figureVideo}
            {figureImage}
            {container}
            {youtubeModal}
          </section>
        </article>
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/hero-video/index.jsx